<template>
  <article>
    <ArticleMastHead
      :title="festival.title"
      :identity="festival.identity"
      :space="festival.space"
      :cover_media="newsCoverMedia"
      :articleID="festival.id"
      :isNested="false"
      :template="$route.meta.articleTemplate"
      :startDate="festival.start_date"
      :endDate="festival.end_date"
      :lunarDate="festival.lunar_date"
      :activityFeature="festival.activity_feature"
      :address="festival.address"
      :updateDate="getOnlyDate(festival.updated_at)"
    />
    <ArticleContainer>
      <template #main>
        <!-- 文章段落 -->
        <ArticleParagraphs
          category="festival"
          :paragraphs="festival.paragraphs"
          :template="$route.meta.articleTemplate"
        />
      </template>
      <template #aside>
        <FestivalAside />
      </template>
    </ArticleContainer>
  </article>
</template>

<script>
import ArticleMastHead from '@/components/article/ArticleMastHead';
import ArticleParagraphs from '@/components/article/ArticleParagraphs';
import ArticleContainer from '@/components/article/ArticleContainer';
import FestivalAside from '@/components/aside/FestivalAside';

export default {
  name: 'TheFestival',
  metaInfo() {
    return {
      title: `${this.festival.title} - 旅遊導覽`,
      meta: [
        {
          vmid: 'og:url',
          property: 'og:url',
          content: this.productionWholeReference,
        },
        {
          vmid: 'og:title',
          property: 'og:title',
          content: `${this.festival.title} | 臺南宗教藝術`,
        },
        {
          vmid: 'og:description',
          property: 'og:description',
          content: this.festival.paragraphs[0].content,
        },
        {
          vmid: 'og:image',
          property: 'og:image',
          content: this.festival.cover_image_url,
        },
      ],
    };
  },
  data() {
    return {};
  },
  computed: {
    festival() {
      return this.$store.getters.festival;
    },
    newsCoverMedia() {
      return this.$store.getters.getCoverMedia('festival');
    },
    productionWholeReference() {
      return `${this.$store.getters.productionHostname}${window.location.pathname}${window.location.search}`;
    },
  },
  async mounted() {
    await this.getFestivalData(this.$route.params.articleId);
    // await lazyloading();
  },
  beforeRouteUpdate(to, from, next) {
    if (to.params.articleId !== from.params.articleId) {
      this.getFestivalData(to.params.articleId);
    }
    next();
  },
  methods: {
    async getFestivalData(articleId) {
      // 載入旅遊文章頁內頁，以 API 資料作為初始值
      try {
        await this.$store.dispatch('getFestival', articleId);
      } catch (e) {
        console.error(e);
      }
    },
    getOnlyDate(date = '2021-12-31 15:00') {
      return date.split(' ')[0];
    },
  },
  components: {
    ArticleMastHead,
    ArticleParagraphs,
    ArticleContainer,
    FestivalAside,
  },
};
</script>
